import { render, staticRenderFns } from "./PlpAttributes26.vue?vue&type=template&id=30d0c8fb&scoped=true"
import script from "./PlpAttributes26.vue?vue&type=script&lang=js"
export * from "./PlpAttributes26.vue?vue&type=script&lang=js"
import style0 from "./PlpAttributes26.vue?vue&type=style&index=0&id=30d0c8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d0c8fb",
  null
  
)

/* custom blocks */
import block0 from "Components/02-molecules/product-info-sections/translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fplp-attributes-26%2FPlpAttributes26.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports